import React from "react";

const CTASection = ({ setShowModal }) => {
  return (
    <section className="py-24">
      <div className="max-w-4xl mx-auto text-center px-4">
        <h2 className="text-4xl md:text-6xl font-bold mb-6">
          Ready to make the
          <br />
          <span className="text-[hsl(30,100%,85%)]">switch?</span>
        </h2>
        <p className="text-xl text-gray-300 mb-12 max-w-2xl mx-auto">
          Join 15+ businesses who've already made the smart choice. Book your demo today.
        </p>
        
        <div className="flex flex-col md:flex-row gap-4 justify-center max-w-lg mx-auto">
          <button 
            onClick={() => setShowModal(true)}
            className="bg-[hsl(30,100%,85%)] text-black px-8 py-4 rounded-full text-lg font-medium hover:bg-white transition-all duration-300 hover:scale-105"
          >
            Book a Demo
          </button>
        </div>
        
        <p className="text-sm text-gray-500 mt-6">No credit card required • Free audit of your current tech-stack •  Site set-up and admin access for free!</p>
      </div>
    </section>
  );
};

export default CTASection; 